import { React, useEffect, useState, useRef, useMemo } from "react";
import { genericGet, genericPost } from "../../services/Api";
import cogoToast from "cogo-toast";
import { Spinner } from "reactstrap";
import { useHistory, Link } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem } from "reactstrap";
import { SUCCESS_RESULT, ENDPOINTS } from "../../Constants";
import CheckboxTree from 'react-checkbox-tree';
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import { EbmsLoading, log } from "../../services/Utils";
import ReactHTMLDatalist from "react-html-datalist";
import "./style.css";
import AppContext from "../../AppContext";
import { AgGridReact } from "ag-grid-react";
import { PERMS } from "../config/perms";
import axios from "axios";
import fileDownload from 'js-file-download';
//SURVEY IMPORTS
import * as SurveyCore from "survey-core";
import { Survey } from 'survey-react-ui';
// import "survey-core/defaultV2.css";
import "survey-creator-core/survey-creator-core.min.css";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { bootstrapThemeName } from "survey-core/plugins/bootstrap-integration";
import { bootstrapMaterialThemeName } from "survey-core/plugins/bootstrap-material-integration";
import { defaultCss } from "survey-core/plugins/bootstrap-material-integration";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

SurveyCore.StylesManager.applyTheme("darkblue");
SurveyCore.Serializer.getProperty('dropdown', 'renderAs').defaultValue = 'select';

const ManagePermissions = (props) => {
    const history = useHistory();
    const [modal, setModal] = useState(false);

    const [isLoading, setIsLoading] = useState(false);
    const [allPermissions, setAllPermissions] = useState([]);
    const [permissionModel, setPermissionModel] = useState(new SurveyCore.Model({}));
    const [currentLastSelection, setCurrentLastSelection] = useState({});
    const [gridApi, setGridApi] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editingPermissionId, setEditingPermissionId] = useState(null);

    //Configs
    const containerStyle = useMemo(() => ({ width: '100%', height: '100%', backgroundColor: "#ffffff" }), []);
    const gridStyle = useMemo(() => ({ height: '100%', width: '100%' }), []);
    const gridRef = useRef();
    const defaultColDef = useMemo(() => {
        return {
            editable: false,
            sortable: true,
            flex: 1,
            minWidth: 100,
            filter: true,
            resizable: true,
        };
    }, []);

    const toggle = () => {
        setModal(!modal);
        // Reset edit mode when closing modal
        if (modal) {
            setIsEditMode(false);
            setEditingPermissionId(null);
            setPermissionModel(new SurveyCore.Model({}));
        }
    };
    
    //create or update permission
    const createPermission = () => {
        // setModal(true);
        let error = permissionModel.isCurrentPageHasErrors;
        if (error) {
            cogoToast.error("Complete the form below", {});
            return;
        } 
        log("PERM: ", permissionModel.data);
        setIsLoading(true);
        
        const endpoint = isEditMode ? ENDPOINTS.UPDATE_PERMISSIONS : ENDPOINTS.CREATE_PERMISSIONS;
        const data = isEditMode ? { ...permissionModel.data, id: editingPermissionId } : permissionModel.data;
        
        genericPost(endpoint, data)
            .then((res) => {
                setIsLoading(false);
                if (res.status == 200) {
                    if (res.data.status == SUCCESS_RESULT) {
                        cogoToast.success(res.data.message, {});
                        toggle();
                        loadPermissions();
                        setIsEditMode(false);
                        setEditingPermissionId(null);
                    } else {
                        cogoToast.error(res.data.message, {});
                    }
                }
            })
            .catch((err) => {
                setIsLoading(false);
                console.log(err);
            });
    }
    
    //load permission for editing
    const loadPermissionForEdit = (permissionId) => {
        setIsLoading(true);
        genericPost(ENDPOINTS.GET_PERMISSION, { id: permissionId })
            .then((res) => {
                setIsLoading(false);
                if (res.status == 200) {
                    if (res.data.status == SUCCESS_RESULT) {
                        let responseData = res.data.data;
                        // Load the template first, then populate with existing data
                        genericGet(ENDPOINTS.NEW_PERMISSION_TEMPLATE, {})
                            .then((templateRes) => {
                                if (templateRes.status == 200 && templateRes.data.status == SUCCESS_RESULT) {
                                    let templateData = templateRes.data.data;
                                    // Create model with template
                                    const model = new SurveyCore.Model(templateData);
                                    model.showNavigationButtons = false;
                                    
                                    // Populate with existing permission data
                                    if (responseData) {
                                        model.data = {
                                            ...model.data,
                                            ...responseData
                                        };
                                    }
                                    
                                    setPermissionModel(model);
                                    setIsEditMode(true);
                                    setEditingPermissionId(permissionId);
                                    setModal(true);
                                }
                            })
                            .catch((err) => {
                                setIsLoading(false);
                                console.log(err);
                            });
                    } else {
                        cogoToast.error(res.data.message, {});
                    }
                }
            })
            .catch((err) => {
                setIsLoading(false);
                console.log(err);
            });
    };
    //load template
    const loadPermissionTemplate = () => {
        setIsEditMode(false);
        setEditingPermissionId(null);
        setIsLoading(true);
        genericGet(ENDPOINTS.NEW_PERMISSION_TEMPLATE, {})
            .then((res) => {
                setIsLoading(false);
                if (res.status == 200) {
                    if (res.data.status == SUCCESS_RESULT) {
                        let responseData = res.data.data;
                        const model = new SurveyCore.Model(responseData);
                        model.showNavigationButtons = false;
                        setPermissionModel(model);
                        setModal(true);
                        // log("DATA",responseData);
                    } else {
                        cogoToast.error(res.data.message, {});
                    }
                }
            })
            .catch((err) => {
                setIsLoading(false);
                console.log(err);
            });
    };
    //get permissions
    const loadPermissions = () => {
        setIsLoading(true);
        genericGet(ENDPOINTS.LOAD_PERMISSIONS, {})
            .then((res) => {
                setIsLoading(false);
                if (res.status == 200) {
                    if (res.data.status == SUCCESS_RESULT) {
                        let responseData = res.data.data;
                        setAllPermissions(responseData);
                        log("PERMS", responseData);
                    } else {
                        cogoToast.error(res.data.message, {});
                    }
                }
            })
            .catch((err) => {
                setIsLoading(false);
                console.log(err);
            });
    };
    // Full texts
    // id	
    // module	
    // name	
    // description	
    // resource_id	
    // level
    // 1 main module 2 sub module 3 actions
    // status
    // 10001 active 10002 inactive
    // created_by	
    // created_at	
    // updated_at	
    // reference_module_permissions_id	
    // action

    useEffect(() => {
        loadPermissions();
        // loadPermissionTemplate();
        return () => { };
    }, []);
    return (
        <div>
            <div class="row">
                <Breadcrumb style={{ backgroundColor: '#ffffff' }} className="ms-1 p-2">
                    <BreadcrumbItem>
                        <Link to="/ebms"> EBMS </Link>
                    </BreadcrumbItem>
                    <BreadcrumbItem active >
                        <Link to="/manage-permissions"> PERMISSIONS </Link>
                    </BreadcrumbItem>
                </Breadcrumb>
            </div>
            <div class="row">
                <center><EbmsLoading data={isLoading} /></center>
                <div class="pull-left">
                    <div style={{ marginTop: "0px", marginBottom: "0px" }} class="pull-right">
                        <div style={{ border: "5px" }} >
                            <div class="btn btn-primary btn-l dropend">
                                <span class="" onClick={loadPermissionTemplate} aria-expanded="false">
                                    <center>

                                        <span style={{ color: "#ffffff" }}><i class="fa fa-plus"></i>&nbsp;New Permission</span></center>
                                </span>

                            </div>
                            {/* <div class="btn btn-primary btn-l dropend">
                                <span class="" data-bs-toggle="modal" data-bs-target="#new-permision-modal" aria-expanded="false">
                                    <center>

                                        <span style={{ color: "#ffffff" }}><i class="fa fa-search"></i>&nbsp;New Permission</span></center>
                                </span>

                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div style={containerStyle}>
                    <div style={{ marginTop: "0px" }} className="grid-wrapper">
                        <div style={gridStyle} className="ag-theme-alpine">

                            <AgGridReact
                                suppressMenuHide={true}
                                ref={gridRef}
                                overlayLoadingTemplate={
                                    '<div class="card-body text-end placeholder-glow"> <div class="placeholder col-9 mb-3"></div><div class="placeholder placeholder-xs col-10"></div><div class="placeholder placeholder-xs col-12"></div><div class="placeholder placeholder-xs col-11"></div> <div class="placeholder placeholder-xs col-8"></div><div class="placeholder placeholder-xs col-10"></div></div>'
                                }
                                onGridReady={(params) => {
                                    setGridApi(params.api);
                                    // params.api.showLoadingOverlay();
                                }}
                                rowData={allPermissions}
                                domLayout={"autoHeight"}
                                animateRows={true}
                                pagination={true}
                                paginationPageSize={50}
                                defaultColDef={defaultColDef}
                                resizable={true}
                                enableCellTextSelection={true}
                                suppressCellSelection={true}
                                columnDefs={[
                                    {
                                        headerName: "#",
                                        filter: false,
                                        maxWidth: 70,
                                        sortable: true,
                                        valueFormatter: function (params) {
                                            return `${parseInt(params.node.id) + 1}`;
                                        },
                                    },
                                    {
                                        headerName: " Permission ID ",
                                        field: "id",
                                        width: 300,

                                        sortable: false,
                                        filter: true,
                                    }
                                    ,
                                    {
                                        headerName: "module",
                                        field: "module",
                                        sortable: true,
                                        filter: true,
                                    },
                                    {
                                        headerName: "Action",
                                        field: "action",
                                        width: 100,
                                        sortable: true,
                                        filter: true,
                                        //suppressMovable: true,
                                        cellRendererFramework: (e) => {
                                            let data = e.data;

                                            return (

                                                <span>
                                                    {
                                                        data['action'] === PERMS.CREATE ?
                                                            <span class="badge bg-green">CREATE</span>
                                                            :
                                                            data['action'] === PERMS.UPDATE ?
                                                                <span class="badge bg-orange">UPDATE</span>
                                                                :
                                                                data['action'] === PERMS.READ ?
                                                                    <span class="badge bg-blue">READ</span>
                                                                    :
                                                                    data['action'] === PERMS.DELETE ?
                                                                        <span class="badge bg-red">DELETE</span>
                                                                        : <span class="badge">UNKNOWN</span>
                                                    }


                                                </span>
                                            );
                                        }
                                    },
                                    {
                                        headerName: "Name",
                                        field: "name",
                                        sortable: true,
                                        filter: true,
                                    },
                                    {
                                        headerName: "Description",
                                        field: "description",
                                        sortable: true,
                                        filter: true,
                                    },
                                    {
                                        headerName: "Managed Resource",
                                        field: "resource_id",
                                        sortable: true,
                                        filter: true,
                                    },
                                    {
                                        headerName: "Permission Level",
                                        field: "level",
                                        sortable: true,
                                        filter: true,
                                    },
                                    {
                                        headerName: "Created BY",
                                        field: "created_by",
                                        sortable: true,
                                        filter: true,
                                    },
                                    {
                                        headerName: "Created At",
                                        field: "created_at",
                                        sortable: true,
                                        filter: true,
                                    },
                                    {
                                        headerName: "Permission Linker",
                                        field: "ref_module",
                                        sortable: true,
                                        filter: true,
                                    },
                                    {
                                        headerName: "Status",
                                        field: "status",
                                        width: 100,
                                        sortable: false,
                                        filter: false,
                                        //suppressMovable: true,
                                        cellRendererFramework: (e) => {
                                            let data = e.data;

                                            return (

                                                <span>
                                                    {data['status'] === SUCCESS_RESULT && (
                                                        <span class="badge bg-green">Active</span>
                                                    )}
                                                    {data['status'] !== SUCCESS_RESULT && (
                                                        <span class="badge bg-orange">Inactive</span>
                                                    )}
                                                </span>
                                            );
                                        }
                                    },
                                    {
                                        headerName: "Actions",
                                        field: "actions",
                                        width: 120,
                                        sortable: false,
                                        filter: false,
                                        pinned: 'right',
                                        cellRendererFramework: (e) => {
                                            let data = e.data;

                                            return (
                                                <span>
                                                    <button
                                                        className="btn btn-sm btn-primary"
                                                        onClick={() => loadPermissionForEdit(data.id)}
                                                        style={{
                                                            padding: '4px 12px',
                                                            fontSize: '12px',
                                                            marginRight: '4px'
                                                        }}
                                                        title="Edit Permission"
                                                    >
                                                        <i className="fa fa-edit"></i> Edit
                                                    </button>
                                                </span>
                                            );
                                        }
                                    }
                                ]}

                            ></AgGridReact>
                        </div>
                    </div>


                </div>
            </div>
            <Modal className="modal-lg" isOpen={modal} toggle={toggle}>
                <ModalHeader cssModule={{
                    fontSize: "100px",
                    color: "#4a54f1",
                    paddingTop: "0px",
                    'modal-title': 'w-100 text-center'
                }} toggle={toggle}>
                    <center>{isEditMode ? 'EDIT PERMISSION' : 'CREATE PERMISSION'}</center>
                </ModalHeader>
                <ModalBody>
                    <center><EbmsLoading data={isLoading} /></center>
                    <Survey style={defaultCss} model={permissionModel} />
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggle}>
                        CANCEL
                    </Button>{' '}
                    <Button color="primary" onClick={createPermission}>
                        {isEditMode ? 'UPDATE PERMISSION' : 'CREATE PERMISSION'}
                    </Button>
                </ModalFooter>
            </Modal>

        </div>

    );
}
export default ManagePermissions;
